"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.GuestbookAPI = void 0;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _NextApiClient = require("./NextApiClient");
var GuestbookAPI = /*#__PURE__*/function () {
  function GuestbookAPI() {
    (0, _classCallCheck2["default"])(this, GuestbookAPI);
  }
  (0, _createClass2["default"])(GuestbookAPI, null, [{
    key: "GuestsTableDt",
    value: function GuestsTableDt(_ref) {
      var orderBy = _ref.orderBy,
        ascending = _ref.ascending,
        page = _ref.page,
        limit = _ref.limit,
        query = _ref.query,
        byColumn = _ref.byColumn;
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (err) {
        console.error(err);
      };
      var params = {
        orderBy: orderBy,
        ascending: ascending,
        page: page,
        limit: limit,
        query: query,
        byColumn: byColumn
      };
      _NextApiClient.NextApiClient.com(this.service, 'GuestsTableDt', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "retrieveGuestByEmail",
    value: function retrieveGuestByEmail(email) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (err) {
        console.error(err);
      };
      var params = {
        guestEmail: email
      };
      _NextApiClient.NextApiClient.com(this.service, 'RetrieveGuestByEmail', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "findGuests",
    value: function findGuests() {
      var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (err) {
        console.error(err);
      };
      var params = {
        query: email
      };
      _NextApiClient.NextApiClient.com(this.service, 'FindGuests', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "guestLogin",
    value: function guestLogin(userEmail, pwd) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        email: userEmail,
        password: pwd
      };
      _NextApiClient.NextApiClient.com(this.service, 'LogGuest', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "registerGuest",
    value: function registerGuest(customer, pwd, pwdConfirm, code) {
      var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function (err) {
        console.error(err);
      };
      var params = {
        Guest: (0, _stringify["default"])(customer),
        pwd: pwd,
        pwdConf: pwdConfirm,
        code: code
      };
      _NextApiClient.NextApiClient.com(this.service, 'RegisterGuest', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "registerShopGuest",
    value: function registerShopGuest(customer) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (err) {
        console.error(err);
      };
      var params = {
        guest: (0, _stringify["default"])(customer)
      };
      _NextApiClient.NextApiClient.com(this.service, 'RegisterShopGuest', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "confirmEmail",
    value: function confirmEmail(email) {
      var endpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.origin + '/#/guestregister';
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (err) {
        console.error(err);
      };
      var params = {
        email: email,
        FeEndpoint: endpoint
      };
      _NextApiClient.NextApiClient.com(this.service, 'ConfirmEmail', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "confirmCode",
    value: function confirmCode(code) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (err) {
        console.error(err);
      };
      var params = {
        code: code
      };
      _NextApiClient.NextApiClient.com(this.service, 'ConfirmCode', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "lostPassword",
    value: function lostPassword(email) {
      var endpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.origin + '/#/guestresetpassword';
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (err) {
        console.error(err);
      };
      var params = {
        email: email,
        FeEndpoint: endpoint
      };
      _NextApiClient.NextApiClient.com(this.service, 'LostPassword', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "resetPassword",
    value: function resetPassword(code, pwd, pwdConf) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (err) {
        console.error(err);
      };
      var params = {
        code: code,
        pwd: pwd,
        pwdConf: pwdConf
      };
      _NextApiClient.NextApiClient.com(this.service, 'ResetPassword', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }]);
  return GuestbookAPI;
}();
exports.GuestbookAPI = GuestbookAPI;
GuestbookAPI.service = 'guestbook';
//# sourceMappingURL=GuestbookAPI.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/api/GuestbookAPI.js
// module id = 1220
// module chunks = 142